import { render, staticRenderFns } from "./instProductInfo.vue?vue&type=template&id=31146236&scoped=true"
import script from "./instProductInfo.vue?vue&type=script&lang=js"
export * from "./instProductInfo.vue?vue&type=script&lang=js"
import style0 from "./instProductInfo.vue?vue&type=style&index=0&id=31146236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31146236",
  null
  
)

export default component.exports